import React from "react";
import { formatMoney } from "utils";

const OpenCloseBalance = ({ type, sum }) => {
  return (
    <div className="d-flex py-2 py-md-3 border-bottom border-1">
      <div className="col-3 fs-xmd-smaller fst-italic text-nowrap pe-3 text-end">
        {formatMoney(sum)}
      </div>
      <b className="fs-6 col-9 fs-xmd-smaller ps-4">
        {type == "open" ? "Open Balance" : "Close Balance"}
      </b>
    </div>
  )
}

export default OpenCloseBalance;
